import moment from 'moment';

/**
 * 获取某个月份的最大天数
 * @param {number|string} year
 * @param {number|string} month
 * @returns {number}
 */
export function getDaysInMonth(year, month) {
  return moment(`${year}-${month}`, 'YYYY-MM').daysInMonth();
}

/**
 * 验证并限制日期范围（年份 1900-2100，月份 1-12，日根据月份/年份限制）
 * @param {number|string} year
 * @param {number|string} month
 * @param {number|string} day
 * @returns {{year: string, month: string, day: string}}
 */
export function validateAndLimitDate(year, month, day) {
  let validYear = parseInt(year) || new Date().getFullYear();
  if (validYear < 1900) validYear = 1900;
  if (validYear > 2100) validYear = 2100;

  let validMonth = parseInt(month) || 1;
  if (validMonth < 1) validMonth = 1;
  if (validMonth > 12) validMonth = 12;

  let validDay = parseInt(day) || 1;
  const maxDay = getDaysInMonth(validYear, validMonth);
  if (validDay < 1) validDay = 1;
  if (validDay > maxDay) validDay = maxDay;

  return {
    year: String(validYear).padStart(4, '0'),
    month: String(validMonth).padStart(2, '0'),
    day: String(validDay).padStart(2, '0'),
  };
}

/**
 * 日期输入格式化：自动过滤非数字字符并格式化为 YYYY、YYYY-MM、YYYY-MM-DD
 * 仅做格式化，不做范围限制（范围限制在失去焦点时通过 validateAndLimitDate 处理）
 * @param {string} inputValue
 * @returns {string}
 */
export function formatDateInput(inputValue) {
  const numbersOnly = inputValue.replace(/\D/g, '');
  if (!numbersOnly) return '';

  if (numbersOnly.length <= 4) {
    return numbersOnly;
  } else if (numbersOnly.length <= 6) {
    const year = numbersOnly.substring(0, 4);
    const month = numbersOnly.substring(4);
    return `${year}-${month}`;
  } else {
    const year = numbersOnly.substring(0, 4);
    const month = numbersOnly.substring(4, 6);
    const day = numbersOnly.substring(6, 8);
    return `${year}-${month}-${day}`;
  }
}
